import React from 'react';
import './usersWaivers.css';
import { connect } from 'react-redux';
import {
  updateUserFilter,
  updateSelectedUser,
  updateSelectedUserWaiver
} from '../../../actions/adminActions/usersActions';
import { users } from '../../../apis/backend'; //make sure to include this for each page
import New from './waiverTabs/new';
import Pending from './waiverTabs/pending';
import Approved from './waiverTabs/approved';
import Rejected from './waiverTabs/rejected';
import AddWaiver from './userModals/addWaiver.jsx';
import NewModal from './userModals/newModal.jsx';
import EditModal from './userModals/editModal.jsx';
import ApprovedModal from './userModals/approvedModal';
import RejectedModal from './userModals/rejectedModal';

class UsersWaivers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userRentalToggle: false,
      userDuplicateToggle: false,
      displayTab: 'new',
      openEdit: false
    };
  }

  async userDeleteRequest(id) {
    await users
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  userToggleRender(user) {
    if (!this.state.userRentalToggle) {
      return '';
    }
    const userRentals = this.props.rentals.filter((obj) => obj.user === user.id);
    if (userRentals.length > 0) {
      for (const rental of userRentals) {
        if (rental.checkInTime === null) {
          return '';
        }
      }
    }
    return 'none';
  }

  getFormattedBirthday(dob) {
    const bday = new Date(dob);
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    return `${months[bday.getMonth()]} ${bday.getDate()}, ${bday.getFullYear()}`;
  }

  getUserFilterType() {
    if (this.state.userDuplicateToggle) {
      // Duplicate user filtering
      const duplicates = this.props.users.filter((user, index, self) => {
        const filterString = `${user.firstName} ${user.lastName} ${
          user.email
        } ${this.getFormattedBirthday(user.dateOfBirth)}`;
        return (
          self.findIndex(
            (t) =>
              t.firstName === user.firstName &&
              t.lastName === user.lastName &&
              t.dateOfBirth !== user.dateOfBirth
          ) >= 0 && filterString.toLowerCase().indexOf(this.props.userFilter.toLowerCase()) > -1
        );
      });
      return duplicates;
    }
    // Return default filtering
    return this.props.users.filter((user) => {
      const filterString = `${user.firstName} ${user.lastName} ${
        user.email
      } ${this.getFormattedBirthday(user.dateOfBirth)}`;
      return filterString.toLowerCase().indexOf(this.props.userFilter.toLowerCase()) > -1;
    });
  }

  getNew() {
    // let test = [
    //   { user: 1, waiver: 1, status: 'pending' },
    //   { user: 2, waiver: 1, status: 'rejected' }
    // ];
    let newWaivers = [];
    this.props.usersWaivers
      .filter((uw) => uw.status == 'new')
      .forEach((uw) => {
        let data = {};
        data.userWaiver = uw;
        data.user = this.props.users.find((user) => user.id == uw.user);
        data.waiver = this.props.waivers.find((waiver) => waiver.id == uw.waiver);
        newWaivers.push(data);
      });
    return newWaivers;
  }

  getPending() {
    // let test = [
    //   { user: 1, waiver: 1, status: 'pending' },
    //   { user: 2, waiver: 1, status: 'rejected' }
    // ];
    let pending = [];
    this.props.usersWaivers
      .filter((uw) => uw.status == 'pending')
      .forEach((uw) => {
        let data = {};
        data.userWaiver = uw;
        data.user = this.props.users.find((user) => user.id == uw.user);
        data.waiver = this.props.waivers.find((waiver) => waiver.id == uw.waiver);
        pending.push(data);
      });
    return pending;
  }

  getApproved() {
    let approved = [];
    this.props.usersWaivers
      .filter((uw) => uw.status == 'approved')
      .forEach((uw) => {
        let data = {};
        data.userWaiver = uw;
        data.user = this.props.users.find((user) => user.id == uw.user);
        data.waiver = this.props.waivers.find((waiver) => waiver.id == uw.waiver);
        approved.push(data);
      });
    return approved;
  }

  getRejected() {
    let rejected = [];
    this.props.usersWaivers
      .filter((uw) => uw.status == 'rejected')
      .forEach((uw) => {
        let data = {};
        data.userWaiver = uw;
        data.user = this.props.users.find((user) => user.id == uw.user);
        data.waiver = this.props.waivers.find((waiver) => waiver.id == uw.waiver);
        rejected.push(data);
      });
    return rejected;
  }

  getUserName() {
    const user = this.props.users.find((obj) => obj.id === this.props.selectedUser);

    return user ? user.firstName + ' ' + user.lastName : '';
  }

  render() {
    return (
      <div className="userswaivers-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>User Waivers</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <div className="btn btn-long btn-dark" data-target="#addWaiver" data-toggle="modal">
              Add Waiver
            </div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <div
              className={
                this.state.displayTab == 'new' ? 'btn btn-sm btn-light' : 'btn btn-sm btn-dark'
              }
              onClick={() => {
                this.setState({ displayTab: 'new' });
              }}
            >
              New
            </div>
            <div
              className={
                this.state.displayTab == 'pending'
                  ? 'btn btn-sm btn-light permission-super-admin'
                  : 'btn btn-sm btn-dark permission-super-admin'
              }
              onClick={() => {
                this.setState({ displayTab: 'pending' });
              }}
            >
              Pending
            </div>
            <div
              className={
                this.state.displayTab == 'approved'
                  ? 'btn btn-sm btn-light permission-super-admin'
                  : 'btn btn-sm btn-dark permission-super-admin'
              }
              onClick={() => {
                this.setState({ displayTab: 'approved' });
              }}
            >
              Approved
            </div>
            <div
              className={
                this.state.displayTab == 'rejected'
                  ? 'btn btn-sm btn-light permission-super-admin'
                  : 'btn btn-sm btn-dark permission-super-admin'
              }
              onClick={() => {
                this.setState({ displayTab: 'rejected' });
              }}
            >
              Rejected
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            {this.state.displayTab == 'new' ? (
              <New
                usersWaivers={this.getNew()}
                setUser={this.props.updateSelectedUser}
                setUserWaiver={this.props.updateSelectedUserWaiver}
              />
            ) : this.state.displayTab == 'pending' ? (
              <Pending
                usersWaivers={this.getPending()}
                setUser={this.props.updateSelectedUser}
                setUserWaiver={this.props.updateSelectedUserWaiver}
              />
            ) : this.state.displayTab == 'approved' ? (
              <Approved
                usersWaivers={this.getApproved()}
                setUser={this.props.updateSelectedUser}
                setUserWaiver={this.props.updateSelectedUserWaiver}
              />
            ) : (
              <Rejected
                usersWaivers={this.getRejected()}
                setUser={this.props.updateSelectedUser}
                setUserWaiver={this.props.updateSelectedUserWaiver}
              />
            )}
          </div>
        </div>

        <AddWaiver />
        <NewModal />
        <EditModal />
        <ApprovedModal />
        <RejectedModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedUser(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getUserName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.userDeleteRequest(this.props.selectedUser);
                    this.props.updateSelectedUser(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedUser(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.admin.admin.users,
  usersWaivers: state.admin.admin.usersWaivers,
  waivers: state.admin.admin.waivers,
  userFilter: state.admin.users.userFilter,
  selectedUser: state.admin.users.selectedUser,
  selectedWaiver: state.admin.users.selectedWaiver,
  employeeToken: state.auth.employeeToken,
  rentals: state.admin.admin.rentals
});

export default connect(mapStateToProps, {
  updateUserFilter,
  updateSelectedUser,
  updateSelectedUserWaiver
})(UsersWaivers);
